module.exports = __webpack_public_path__ + "img/swap.f6ce32a.png";